import nail_polish_icon from "../global/assets/images/icon-supplies-nailpolish.svg";
import contacts_icon from "../global/assets/images/icon-supplies-contacts.svg";
import pumice_icon from "../global/assets/images/icon-supplies-pumice.svg";
import robe_icon from "../global/assets/images/icon-supplies-robe.svg";
import soap_icon from "../global/assets/images/icon-supplies-soap.svg";
import towel_icon from "../global/assets/images/icon-supplies-towel.svg";
import iconFloss from "../global/assets/images/icon-supplies-floss.svg";
import iconTweezers from "../global/assets/images/icon-supplies-tweezers.svg";
import iconNailClippers from "../global/assets/images/icon-supplies-nailclippers.svg";
import iconCottonPads from "../global/assets/images/icon-supplies-cottonpads.svg";
import iconLargeComb from "../global/assets/images/icon-supplies-largecomb.svg";
import iconNailFile from "../global/assets/images/icon-supplies-nailfile.svg";
import iconQTips from "../global/assets/images/icon-supplies-qtips.svg";
import iconScissors from "../global/assets/images/icon-supplies-scissors.svg";
import iconSmallComb from "../global/assets/images/icon-supplies-smallcomb.svg";
import iconToothbrush from "../global/assets/images/icon-supplies-toothbrush.svg";
import iconToothpaste from "../global/assets/images/icon-supplies-toothpaste.svg";
import iconShaver from "../global/assets/images/icon-supplies-shaver.svg";

const localProps = {
  supplies: [
    { title: "Shaver", icon: iconShaver, selected: false },
    { title: "Pumice Stone", icon: pumice_icon, selected: false },
    { title: "Nail polish remover", icon: nail_polish_icon, selected: false },
    { title: "Large Robe", icon: robe_icon, selected: false },
    { title: "Bar of soap", icon: soap_icon, selected: false },
    { title: "Contact lens solution and case", icon: contacts_icon, selected: false},
    { title: "Tweezers", icon: iconTweezers, selected: false},
    { title: "Nail Scissors", icon: iconScissors, selected: false},
    { title: "Nail Clippers", icon: iconNailClippers, selected: false},
    { title: "Nail File", icon: iconNailFile, selected: false},
    { title: "Toothbrush", icon: iconToothbrush, selected: false},
    { title: "Toothpaste", icon: iconToothpaste, selected: false},
    { title: "Dental Floss", icon: iconFloss, selected: false },
    { title: "Small Comb", icon: iconSmallComb, selected: false},
    { title: "Wide Tooth Comb", icon: iconLargeComb, selected: false},
    { title: "Towel", icon: towel_icon, selected: false },
    { title: "Makeup remover pads", icon: iconCottonPads, selected: false },
    { title: "Q-tips", icon: iconQTips, selected: false },
    { title: "Other", icon: null, selected: false }
    ],
  locations: [],
  paymentItems: [
    'Donation', 'Sponsor a Bride', 'Friend of the Mikvah', 'Yahrzeit', 'Membership', 'Purchase', 'Shabbos Payment', 'Other'
  ],
  languages: [
    {name: 'en', title: 'English'},
    {name: 'he', title: 'עברית'},
    {name: 'es', title: 'Español'},
  ]  
}

const siteSettings = {
  hasParking: false,
  hasExtraTime: true,
  membershipLabel: "Discount Pricing",
  discountPriceLabel: "Request Discount Price",
  emergencyButton: false,
  garageDoorPopup: false,
  showQuickCleaned: false,
  showWaitingOnAllTasks: false,
  showReservationsBathShower: false,
  showShkiaRoomScreen: false,
  allowGuestCheckin: true,
  hasSegula: false,
  hasOvertimeMessage: true,
  hasChabadBorAsOption: false,
  usingYemot: false,
  showSectionMap: true,
  showUserNameinResDetails: true
}

const logoImageAltText = "Los Angeles Mikvah";

export { logoImageAltText, localProps, siteSettings };